import React, { Component } from 'react';
import { func, string } from 'prop-types';
import Radium from 'radium';
import { UTButton, UTLabel } from '@widergy/energy-ui';

import SecondaryTopbar from 'app/components/SecondaryTopbar';
import UTSwitch from 'app/components/UTSwitch';
import { message } from 'utils/stringUtils';
import { currentUserPropTypes } from 'redux/authHandlers';
import { appConfig } from 'config/customization';

import ChangePasswordForm from './components/ChangePasswordForm';
import ConfigurationField from './components/ConfigurationField';
import ConfigurationOpenableRow from './components/ConfigurationOpenableRow';
import ChangePrimaryEmail from './components/ChangePrimaryEmail';
import styles from './styles';
import LockerIcon from './components/Icons/LockerIcon';
import UserProfileIcon from './components/Icons/UserProfileIcon';
import MailIcon from './components/Icons/MailIcon';
import PhoneIcon from './components/Icons/PhoneIcon';

class Configuration extends Component {
  state = {
    notifications: false,
    showNotificationConfiguration: false, // TODO: Notifications disabled for now.
    emailChangeModalIsOpen: false
  };

  handleNotifications = () => this.setState({ notifications: !this.state.notifications });

  handleOpenChangeEmailModal = () =>
    this.setState({
      emailChangeModalIsOpen: true
    });

  handleCloseChangeEmailModal = () =>
    this.setState({
      emailChangeModalIsOpen: false
    });

  render() {
    return (
      <div>
        <SecondaryTopbar
          titleText={message('Configuration:configurationSummary')}
          iconAltText={message('Configuration:configurationSummary')}
        />
        <div style={styles.configurationContainer}>
          <ConfigurationField
            style={styles.userRow}
            title={message('Configuration:user')}
            Icon={UserProfileIcon}
            iconColor={appConfig.colors.iconColors}
          >
            <UTLabel darkGray>{this.props.userName}</UTLabel>
          </ConfigurationField>
          <ConfigurationField
            style={styles.userInfoRow}
            title={message('Commons:email')}
            Icon={MailIcon}
            iconColor={appConfig.colors.iconColors}
          >
            <div style={[appConfig.canChangePrimaryEmail && styles.emailContainer]}>
              <UTLabel style={styles.email} darkGray>
                {this.props.email}
              </UTLabel>
              {appConfig.canChangePrimaryEmail && (
                <UTButton onPress={this.handleOpenChangeEmailModal}>
                  {message('Configuration:change')}
                </UTButton>
              )}
            </div>
            {appConfig.canChangePrimaryEmail && (
              <ChangePrimaryEmail
                onCloseModal={this.handleCloseChangeEmailModal}
                modalIsOpen={this.state.emailChangeModalIsOpen}
              />
            )}
          </ConfigurationField>
          <ConfigurationField
            title={message('Configuration:userInformation')}
            style={styles.userRow}
            Icon={PhoneIcon}
            iconColor={appConfig.colors.iconColors}
          >
            <UTButton
              disabled={this.props.user.is_customer === false}
              onPress={this.props.onGoToChangeUserInfo}
            >
              {message('Configuration:change')}
            </UTButton>
          </ConfigurationField>
          <ConfigurationOpenableRow
            style={styles.userInfoRow}
            title={message('Configuration:changePassword')}
            Icon={LockerIcon}
            iconColor={appConfig.colors.iconColors}
          >
            <ChangePasswordForm
              onSubmit={this.props.onChangePassword}
              onGoToDashboard={this.props.onGoToDashboard}
            />
          </ConfigurationOpenableRow>
          {this.state.showNotificationConfiguration && (
            <ConfigurationField
              title={message('Configuration:notifications')}
              description={message('Configuration:notificationsSettingDescription')}
            >
              <UTSwitch value={this.state.notifications} onClick={this.handleNotifications} withLabel />
            </ConfigurationField>
          )}
        </div>
      </div>
    );
  }
}

Configuration.propTypes = {
  userName: string.isRequired,
  user: currentUserPropTypes.isRequired,
  onChangePassword: func.isRequired,
  email: string,
  onGoToChangeUserInfo: func.isRequired,
  onGoToDashboard: func
};

export default Radium(Configuration);
